import { Injectable } from '@angular/core';
import { Event } from '../entity/Event';
import { catchError, concatMap, from, Observable, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { OfflineDatabase } from '../repository/OfflineDatabase';
import { PromotionCode } from '@smartnowx/hcms-plugin-event-manager';
import { PromotionCodeService as ParentPromotionCodeService } from '@smartnowx/hcms-plugin-event-manager';
import { IConstants } from '../IConstants';

@Injectable({
  providedIn: 'root',
})
export class PromotionCodeService {
  constructor(
    private http: HttpClient,
    private db: OfflineDatabase,
    private parentPromotionCodeService: ParentPromotionCodeService
  ) {}

  synchronizePromotionCodes(events: Event[]): Observable<void> {
    return from(this.db.promotion_codes.clear()).pipe(
      tap(() => console.log('Promotion codes törölve.')),
      concatMap(() => from(events).pipe(
        concatMap((event) =>
          this.downloadPromotionCodes(event.organization_id).pipe(
            tap(() => console.log(`Promotion codes for event ${event.id} synchronized.`))
          )
        )
      )),
      tap(() => console.log('All promotion codes are synchronized.'))
    );
  }

  public downloadPromotionCodes(organizationId: number) {
    return this.http
      .get<PromotionCode[]>(
        environment.HOST +
          environment.API_PATH_PREFIX +
          'organizations/' +
          organizationId +
          '/promotion-codes'
      )
      .pipe(
        tap((d) => {
          const downloadedCodes = d as PromotionCode[];
          // downloadedCodes.synchronizedAt = new Date();

          this.db.promotion_codes.bulkPut(downloadedCodes);
          console.log('Promotion codes downloaded: ' + downloadedCodes.length);
        }),
        catchError((e) => {
          console.log(e);
          // this.db.promotion_codes.delete(eventId);
          return of(e);
        })
      );
  }

  public validatePromotionCode(code: string): Observable<any> {
    return this.isOfflineMode()
      ? this.validatePromotionCodeOffline(code)
      : this.validatePromotionCodeOnline(code);
  }

  public toggleMode() {
    this.setMode(this.isOfflineMode() ? false : true);
  }

  public isOfflineMode(): boolean {
    return JSON.parse(
      localStorage.getItem(IConstants.CONSTANT_OFFLINE_MODE_STORAGE_NAME) ||
        'false'
    );
  }

  public setMode(mode: boolean): void {
    localStorage.setItem(
      IConstants.CONSTANT_OFFLINE_MODE_STORAGE_NAME,
      JSON.stringify(mode)
    );
  }

  validatePromotionCodeOffline(
    code: string
  ): Observable<PromotionCode | undefined> {
    console.log('Validating promotion code offline: ' + code);
    return from(
      this.db.promotion_codes
        .where('code')
        .equalsIgnoreCase(code.trim())
        .first()
    );
  }

  validatePromotionCodeOnline(code: string): Observable<PromotionCode> {
    console.log('Validating promotion code online: ' + code);
    return this.parentPromotionCodeService.validateCode(code.trim());
  }
}
